import * as React from 'react'

import { ContextProps, setDefaultModalConfig, ModalProps } from './types'

export const ModalConfigCtx = React.createContext<ModalProps | null>(null)
export const ModalDefaultProvider: React.FunctionComponent<ContextProps> = ({
  children,
  ...props
}) => (
  <ModalConfigCtx.Provider value={setDefaultModalConfig(props)}>
    {children}
  </ModalConfigCtx.Provider>
)

export const IdCtx = React.createContext<string | null>(null)
